import { styled } from '@mui/material';

import { AvatarWrapper } from '../wrapper';

export const AvatarProfile = styled( AvatarWrapper )(() => ({
  width: '120px',
  height: '120px',
}));
